import { _TableDetailViewScreenInstance_Type } from "../../../src/library/table/tableapi"
let instances: { [key: string]: _TableDetailViewScreenInstance_Type } = {}
export let SYSTableDetailView = { instances }
